// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"b2129e6b","703":"5e8e5e53","787":"7e722b52"}[chunkId] + ".chunk.js";
};